<template>
  <el-drawer :visible.sync="visible" size="min(920px, 96vw)" append-to-body>
    <template slot="title">
      <span class="viewer-title">可查看人员 <strong>{{ company.companyManager }}</strong><el-tag size="mini" type="info">只读</el-tag></span>
    </template>
    <div class="company-users-viewer">
      <div class="viewer-content">
        <p class="viewer-note"><i class="el-icon-info"></i> 按已保存的公司及品牌配置展示；如需调整，请前往人员配置。</p>
        <el-form :inline="true" size="small" class="viewer-filters" @submit.native.prevent="search">
          <el-form-item><el-input v-model="params.keyword" placeholder="搜索姓名或账号" prefix-icon="el-icon-search" clearable @keyup.enter.native="search" /></el-form-item>
          <el-form-item label="在职状态"><el-select v-model="params.quitStatus" placeholder="全部" clearable><el-option label="在职" :value="1" /><el-option label="离职" :value="2" /></el-select></el-form-item>
          <el-form-item><el-button type="primary" @click="search">查询</el-button><el-button @click="reset">重置</el-button></el-form-item>
        </el-form>
        <div v-if="loadError" class="viewer-error" role="alert"><span>{{ loadError }}</span><el-button type="text" @click="load">重新加载</el-button></div>
        <el-table v-else v-loading="loading" :data="rows" size="small" stripe empty-text="暂无配置为可查看此公司的人员" class="viewer-table">
          <el-table-column prop="userName" label="姓名" width="100" show-overflow-tooltip />
          <el-table-column prop="account" label="账号" width="130" show-overflow-tooltip />
          <el-table-column label="状态" width="105">
            <template slot-scope="scope"><span>{{ scope.row.quitStatus === 1 ? '在职' : scope.row.quitStatus === 2 ? '离职' : '未设置' }}</span><el-tag v-if="scope.row.status === 1" type="info" size="mini" class="disabled-tag">已停用</el-tag></template>
          </el-table-column>
          <el-table-column label="本公司品牌及地区" width="200">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.allBrands" size="small" effect="plain">全部品牌</el-tag>
              <div v-else-if="scope.row.brands.length" class="viewer-brands"><el-tag v-for="brand in scope.row.brands" :key="brand.brandId" size="small" type="info" effect="plain">{{ brand.brandName }}</el-tag></div>
              <span v-else class="viewer-note">未配置品牌</span>
              <div v-for="region in scope.row.brandRegions || []" :key="region.brandId" class="viewer-region">{{ region.brandName }}：{{ region.regions.map(path => path.names.join(' / ')).join('、') }}</div>
              <div class="viewer-note">{{ (scope.row.brandRegions || []).length ? '其余已选品牌：全国' : '地区：全国' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="拥有公司范围" min-width="120"><template slot-scope="scope"><span>{{ scope.row.allCompanies ? '全部公司' : '指定公司' }}</span></template></el-table-column>
          <el-table-column v-if="canConfigure" label="操作" width="120" fixed="right"><template slot-scope="scope"><el-button type="text" size="mini" @click="configure(scope.row)">前往人员配置</el-button></template></el-table-column>
        </el-table>
        <el-pagination v-if="!loadError" class="viewer-pagination" small background :current-page="params.page" :page-size="params.size" :total="total" layout="total, prev, pager, next" @current-change="changePage" />
      </div>
      <div class="viewer-footer"><span class="viewer-note">配置修改统一在人员管理中完成</span><el-button size="small" @click="visible = false">关闭</el-button></div>
    </div>
  </el-drawer>
</template>

<script>
import { authorization } from "../../../authorization/authorization";

export default {
  name: "CompanyAccessUsers",
  data() {
    return {
      visible: false, loading: false, loadError: "", company: {}, rows: [], total: 0,
      params: { page: 1, size: 10, keyword: "", quitStatus: "" }, requestSequence: 0,
    };
  },
  computed: {
    canConfigure() {
      return authorization("/home-admin/routineManage/user-list") && authorization("/home-admin/routineManage/user-list/company-manage");
    },
  },
  methods: {
    open(company) {
      this.company = { companyId: company.companyId, companyManager: company.companyManager };
      this.params = { page: 1, size: 10, keyword: "", quitStatus: "" };
      this.rows = []; this.total = 0; this.visible = true;
      this.load();
    },
    async load() {
      const requestId = ++this.requestSequence;
      this.loading = true; this.loadError = "";
      try {
        const response = await this.axios.get("/v1/web/user-company-access/company/" + encodeURIComponent(this.company.companyId) + "/users", { params: this.params });
        if (requestId !== this.requestSequence) return;
        if (response.data.code !== 200) throw new Error(response.data.message || "加载失败");
        this.rows = response.data.data.list;
        this.total = response.data.data.total;
      } catch (error) {
        if (requestId === this.requestSequence) { this.rows = []; this.total = 0; this.loadError = error.message || "加载失败，请重试"; }
      } finally { if (requestId === this.requestSequence) this.loading = false; }
    },
    search() { this.params.page = 1; this.load(); },
    reset() { this.params = { page: 1, size: 10, keyword: "", quitStatus: "" }; this.load(); },
    changePage(page) { this.params.page = page; this.load(); },
    configure(user) {
      if (!this.canConfigure) return;
      this.visible = false;
      this.$router.push({
        path: "/home-admin/routineManage/user-list",
        query: { companyAccessUserId: String(user.id), focusCompanyId: this.company.companyId },
      });
    },
  },
};
</script>

<style scoped>
.viewer-title { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; color: #303133; font-size: 16px; }
.viewer-title strong { font-size: 14px; }
.company-users-viewer { display: flex; flex-direction: column; height: 100%; color: #303133; }
.viewer-content { flex: 1; min-height: 0; overflow: auto; padding: 0 24px 20px; }
.viewer-note { color: #73767a; font-size: 12px; line-height: 20px; margin: 0; }
.viewer-filters { margin-top: 18px; }
.viewer-filters .el-input { width: 185px; }
.viewer-filters .el-select { width: 110px; }
.viewer-table { width: 100%; }
.viewer-brands { display: flex; flex-wrap: wrap; gap: 6px; padding: 3px 0; }
.viewer-brands .el-tag { height: auto; white-space: normal; overflow-wrap: anywhere; }
.viewer-region { color: #606266; font-size: 12px; line-height: 20px; margin-top: 6px; overflow-wrap: anywhere; }
.disabled-tag { margin-left: 4px; }
.viewer-pagination { text-align: right; margin-top: 18px; white-space: normal; }
.viewer-footer { border-top: 1px solid #ebeef5; padding: 16px 24px; display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.viewer-error { padding: 28px 0; color: #f56c6c; }
@media (max-width: 620px) { .viewer-content { padding: 0 16px 16px; } .viewer-footer { padding: 12px 16px; flex-wrap: wrap; } }
</style>
